import { FilterProperties } from '../constants/lead';
import * as R from 'ramda';
const axios = require('axios');

const baseUrl = 'https://3b4t2hwmqb.execute-api.ap-south-1.amazonaws.com/dev';
// const baseUrl = 'http://localhost:8081';

const sleep = t => new Promise(s => window.setTimeout(s, t));

function loginAPI(email, password) {
  return axios.post(`${baseUrl}/login`, {
    email,
    password
  })
    .then((response) => {
      console.log(`response.data = ${JSON.stringify(response.data)}`);
      return response.data;
    });
  // console.log(`Login API called with email=${email} and password=${password}`);
}

function getLeadData(filter) {
  console.log(`filter = ${JSON.stringify(filter)}`)
  let filterCondition = { };
  R.forEach((propKey) => {
    let prop = FilterProperties[propKey];
    let propName = prop['APP_NAME'];
    if (R.has(propName)(filter) && !R.isNil(filter[propName]) && (filter[propName].length > 0 || typeof filter[propName] === 'number')) {
      console.log(`Adding to filterCondition ${filter[propName].length} and ${propName}`);
      filterCondition[propName] = filter[propName];
    }
  })(FilterProperties.PropertiesList);

  const token = window.localStorage.getItem('token');
  return axios.post(`${baseUrl}/leads`, {
    filterCondition
  }, { headers: { Authorization: `Bearer ${token}`}})
    .then((response) => {
      console.log(`response.data = ${JSON.stringify(response.data)}`);
      return { data: response.data };
    });
}

function getLeadInformation(leadId) {
  const token = window.localStorage.getItem('token');
  return axios.get(`${baseUrl}/leads/info?leadId=${leadId}`, {
    headers: { Authorization: `Bearer ${token}`}
  })
    .then((response) => {
      console.log(`response.data.actions = ${JSON.stringify(response.data.actions)}`);
      R.forEach(action => {
        action.date = new Date(action.date*1000).toLocaleString();
      })(response.data.actions.actions);
      response.data.lead.lastUpdatedDate = new Date(response.data.lead.lastUpdatedDate*1000).toLocaleString();

      R.forEach(enquiry => {
        enquiry.dateOfEnquiry = new Date(enquiry.dateOfEnquiry*1000).toLocaleString();
      })(response.data.lead.enquiries);
      return response.data;
    });
}

function addLeadAction(leadId, action) {
  const token = window.localStorage.getItem('token');
  return axios.post(`${baseUrl}/leads/action`, {
    leadId,
    action
  }, { headers: { Authorization: `Bearer ${token}` }})
    .then((response) => {
      return response.data;
    })
}

function _exportLeads(filterCondition, params) {
  const token = window.localStorage.getItem('token');
  return axios.post(`${baseUrl}/leads/export`, {
    filterCondition,
    params
  }, { headers: { Authorization: `Bearer ${token}` }})
    .then((response) => {
      return response.data
    });
}

function _getLeadReports(filterCondition) {
  const token = window.localStorage.getItem('token');
  return axios.post(`${baseUrl}/leads/report`, {
    filterCondition
  }, { headers: { Authorization: `Bearer ${token}` }})
    .then((response) => {
      return response.data
    });
}

function getCourses() {
  const token = window.localStorage.getItem('token');
  return axios.get(`${baseUrl}/courses`, {
    headers: { Authorization: `Bearer ${token}` }
  })
    .then(response => response.data);
}

function addMessageTemplate(templateName, templateSubject, templateContent, templateParams) {
  const token = window.localStorage.getItem('token');
  return axios.post(`${baseUrl}/template`, {
    templateName,
    templateSubject,
    templateContent,
    templateParams
  }, { headers: { Authorization: `Bearer ${token}` }})
    .then(response => {
      return response.data;
    });
}

function getMessageTemplates() {
  const token = window.localStorage.getItem('token');
  return axios.get(`${baseUrl}/templates`, {
    headers: { Authorization: `Bearer ${token}`}
  })
    .then(response => response.data);
}

function sendEmailMessage(emails, templateId) {
  const token = window.localStorage.getItem('token');
  return axios.post(`${baseUrl}/lead/emails`, {
    emails,
    templateId
  }, { headers: { Authorization: `Bearer ${token}` }})
    .then(response => response.data);
}

/**
 * Reporting API Calls
 */

function _getMarketingReport(filterCondition) {
  const token = window.localStorage.getItem('token');
  return axios.post(`${baseUrl}/report/marketing`, {
    filterCondition
  }, { headers: { Authorization: `Bearer ${token}` }})
    .then((response) => {
      return response.data
    });
}

function _getFunnelReport(filterCondition) {
  const token = window.localStorage.getItem('token');
  return axios.post(`${baseUrl}/report/funnel`, {
    filterCondition
  }, { headers: { Authorization: `Bearer ${token}` }})
    .then((response) => {
      return response.data
    });
}

function _getTotalReport(email, startDate, endDate) {
  const token = window.localStorage.getItem('token');
  return axios.post(`${baseUrl}/report/total`, {
    email,
    startDate,
    endDate
  }, { headers: { Authorization: `Bearer ${token}` }})
    .then((response) => {
      return response.data;
    });
}

export {
  loginAPI,
  getLeadData,
  addLeadAction,
  getLeadInformation,
  addMessageTemplate,
  getMessageTemplates,
  sendEmailMessage,
  getCourses,
  _exportLeads,
  _getLeadReports,
  _getTotalReport,
  _getMarketingReport,
  _getFunnelReport
};
